import axios from 'axios'
import {baseUrl} from '../config'
import {IAnswer} from '../../types/answer'

export function getAnswers(electionId: number, candidateId: number): Promise<IAnswer[]> {
  return axios.get(`${baseUrl}/${candidateId}/election/${electionId}/answers`).then(response => response.data)
}

export function upsertAnswer(electionId: number, candidateId: number | string, answer: Partial<IAnswer>): Promise<IAnswer> {
  return axios
    .post(`${baseUrl}/${candidateId}/election/${electionId}/answers`, {
      ...answer
    })
    .then(response => response.data)
}
